<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Address + Coverage Area</strong>
      </div>

      <AddressDialog :pro="currentPro" v-if="isEditable(currentPro) && userIsAdmin" />
    </template>

    <Item icon="mdi-map-marker">
        <strong>
          {{ currentPro.address.street }}, {{ currentPro.address.city }}, 
          {{ currentPro.address.state }}, {{ currentPro.address.zipcode }}
          - {{ currentPro.coverage_radius }} mi
        </strong>
    </Item>
    <l-map v-if="currentPro.address.place_id" style="height: 200px" :zoom="zoom" 
      :center="center" ref="theMap" @ready="mapReady" :options="{ zoomControl: false }"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="center" />
      <l-circle v-if="currentPro.coverage_radius" :lat-lng="center" :radius="radius" color="green" />
    </l-map>
    <div v-if="currentPro.address.place_id==null && isEditable(currentPro)"
      class="grey lighten-2 text-center d-flex flex-column justify-center text--bold" 
      style="height: 200px; font-size: 20px;"
    >
      Please confirm this address<br><br>
      <span style="font-size: 14px;">Edit the address above and choose an<br>address from the autocomplete list.</span>
    </div>


  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import AddressDialog from '../dialogs/Address'
  import { latLng } from "leaflet"
  import { LCircle, LMarker, LMap, LTileLayer } from 'vue2-leaflet'
  import { mapGetters } from 'vuex'
  import proMixin from '../proMixin'

  export default {
    name: 'ProAddressSection',
    
    mixins: [proMixin],

    components: { AddressDialog, Section, Item, LCircle, LMarker, LMap, LTileLayer },

    data() {
      return {
        zoom: 8,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      }
    },

    computed: {
      ...mapGetters ('auth', ['userIsAdmin']),
      ...mapGetters ('pros', ['currentPro']),

      center() {
        return latLng(this.currentPro.address.latitude, this.currentPro.address.longitude)
      },

      radius() { 
        // in meters
        return this.currentPro.coverage_radius * 1609.34
      },
    },

    methods: {
      mapReady() {
        const map = this.$refs.theMap.mapObject

        map.touchZoom.disable()
        map.doubleClickZoom.disable()
        map.scrollWheelZoom.disable()
        map.boxZoom.disable()
        map.keyboard.disable()
        map.dragging.disable()
      },
    }

  }
</script>